"use client"

import { useState } from "react"
import { ChevronDown, HelpCircle } from "lucide-react"

import styles from "./Faq.module.scss"

export default function FAQ() {
  const [expandedItem, setExpandedItem] = useState(0)

  const faqItems = [
    {
      question: "No recibí el Token de actualización de contraseña. ¿Qué hago?",
      answer: `<p>Verifica que el correo con el que estás solicitando el cambio de contraseña corresponde a la cuenta con la que has estado suscrito a <strong>TCS GO!</strong></p>
        <p>Si el correo efectivamente corresponde a tu cuenta activa TCS GO!, comunícate con nuestro equipo de soporte al <a href="https://wa.me/50369383613" target="_blank" rel="noopener noreferrer">WhatsApp</a> para solicitar un cambio de contraseña manual.</p>`,
    },
    {
      question: "Pagué mi suscripción y no se activó el servicio.",
      answer: `<p>Comprueba que tienes una suscripción activa de acuerdo con la plataforma en la que te hayas suscrito:</p>
        <ul>
          <li><strong>Apple ID:</strong> Apartado "Apple ID" en Configuración / "Suscripciones" / Elige la aplicación TCS GO! para comprobar su estado.</li>
          <li><strong>Google Play Store:</strong> Apartado "Pagos y Suscripciones" / "Suscripciones" / Elige la aplicación TCS GO! para administrar tu suscripción y comprobar su estado.</li>
          <li><strong>TCSGO.com:</strong> inicia sesión, presiona el ícono de usuario al extremo derecho de la pantalla y dirígete a "Pagos". Ahí podrás comprobar si tienes una suscripción activa.</li>
        </ul>`,
    },
    {
      question: "¿Cuáles son las formas de pago para suscribirme a TCS GO?",
      answer: `<p>Las vías oficiales para suscripción son:</p>
        <ul>
          <li>Directamente entrando en tu navegador a <strong>www.tcsgo.com</strong>.</li>
          <li>Descargando la <strong>App TCS GO</strong> en tu dispositivo iOS, tvOS, Android o Android TV.</li>
        </ul>
        <p><strong>Métodos de pago:</strong></p>
        <ul>
          <li>Tarjetas de crédito o débito asociadas a tus dispositivos.</li>
          <li>Tarjetas de crédito o débito en www.tcsgo.com.</li>
        </ul>
        <p>A partir de agosto 2024, podrás comprobar tu pago al recibir un correo electrónico con los detalles de la suscripción.</p>`,
    },
    {
      question: "¿Cómo puedo cancelar mi suscripción?",
      answer: `<ul>
          <li><strong>iOS:</strong> apartado "Apple ID" en Configuración / "Suscripciones" / elige la aplicación TCS GO! / Cancelar suscripción.</li>
          <li><strong>Android en Play Store:</strong> apartado "Pagos y Suscripciones" / "Suscripciones" / elige la aplicación TCS GO! / Administrar suscripción / Cancelar suscripción.</li>
          <li><strong>TCSGO.com:</strong> inicia sesión, presiona el ícono de usuario al extremo derecho de la pantalla y dirígete a "Pagos". Cancela tu suscripción. Si no puedes realizarlo por esa vía, solicita a nuestro equipo de soporte la cancelación de tu cuenta.</li>
        </ul>`,
    },
    {
      question: "¿Cómo iniciar sesión en Smart TV? (TUTORIAL)",
      answer: `<ul>
          <li><strong>Apple TV:</strong> ve a App Store, descarga la aplicación y ábrela. La plataforma te solicitará escanear un código QR con tu celular, que te llevará a una pantalla donde deberás ingresar tus credenciales.</li>
          <li><strong>Android TV:</strong> ve a Google Play Store, descarga la aplicación y ábrela. La plataforma te solicitará escanear un código QR con tu celular, que te llevará a una pantalla donde deberás ingresar tus credenciales.</li>
        </ul>`,
    },
    {
      question: "¿Qué puedo ver en vivo en TCS GO?",
      answer: `<p>La programación de TCS GO varía según el país en el que te encuentres. Tenemos 3 categorías de programación:</p>
        <ul>
          <li><strong>El Salvador:</strong> visita <a href="/programacion" rel="noopener noreferrer">Programación TCS GO!</a>.</li>
          <li><strong>Estados Unidos:</strong> navega el sitio <a href="https://www.tcsgo.com/" target="_blank" rel="noopener noreferrer">tcsgo.com</a> para conocer los contenidos disponibles en tu país.</li>
          <li><strong>Resto del mundo:</strong> navega el sitio <a href="https://www.tcsgo.com/" target="_blank" rel="noopener noreferrer">tcsgo.com</a> para conocer los contenidos disponibles en tu país.</li>
        </ul>`,
    },
    {
      question: "¿Dónde puedo conocer la programación Deportiva de TCS GO?",
      answer: `<p>Para El Salvador: <a href="/programacion" rel="noopener noreferrer">Programación TCS GO!</a></p>
        <p>Para USA y resto del mundo: visita nuestras redes sociales para encontrar información actualizada sobre los eventos deportivos disponibles en TCS GO.</p>`,
    },
    {
      question: "¿Por qué solo puedo ver los partidos con WiFi?",
      answer: `<p>La transmisión del Mundial FIFA 2026 en TCS GO está disponible únicamente a través de una conexión WiFi. Por derechos de transmisión, no es compatible con datos móviles, independientemente del operador o plan que tengas.</p>
        <p>Para disfrutar los partidos sin interrupciones, asegúrate de estar conectado a una red WiFi estable y de tener la app actualizada a la última versión.</p>
        <p>Si estás en WiFi y aún tienes problemas, contáctanos a través de nuestro canal de <a href="https://bit.ly/WATCSGO" target="_blank" rel="noopener noreferrer">WhatsApp</a> y un agente te ayudará.</p>`,
    },
    {
      question: "¿Por qué no están todos los partidos del Mundial en TCS GO?",
      answer: `<p>TCS GO transmite en streaming los partidos del Mundial FIFA 2026 que van por la señal del Canal 4. En total son 40 partidos dentro de El Salvador, no todos los encuentros del torneo están incluidos en nuestra cobertura.</p>
        <p>Consulta el calendario completo de partidos disponibles aquí: <a href="https://www.tcsahora.com/copa-mundial-fifa-2026/" target="_blank" rel="noopener noreferrer">https://www.tcsahora.com/copa-mundial-fifa-2026/</a></p>
        <p>Si el partido que buscas no aparece en ese calendario, no forma parte de la transmisión de Canal 4 para este torneo.</p>`,
    },
    {
      question: "No puedo ver un contenido.",
      answer: `<p>Repórtalo a nuestro equipo de soporte <a href="https://wa.me/50369383613" target="_blank" rel="noopener noreferrer">por WhatsApp</a> para recibir asistencia inmediata.</p>`,
    },
    {
      question: "Consulta no relacionada al servicio TCS GO!",
      answer: `<p>Si tienes una consulta no relacionada al servicio TCS GO!, pero sí a Telecorporación Salvadoreña, puedes enviar un correo a: <a href="mailto:info.mercadeo@tcs246.com">info.mercadeo@tcs246.com</a></p>`,
    },
  ]

  return (
    <div className={styles.pageWrapper}>
      <main className={styles.pageMain}>
        <div className={styles.container}>
          <section className={styles.heroSection}>
            <div className={styles.heroContent}>
              <div className={styles.faqIconWrapper}>
                <HelpCircle className={styles.faqIcon} />
              </div>

              <h1 className={styles.heroTitle}>Centro de Ayuda</h1>

              <p className={styles.heroSubtitle}>
                Encuentra respuestas a las preguntas más comunes sobre tu suscripción a TCS GO
              </p>
            </div>
          </section>

          <section className={styles.faqContainer}>
            <div className={styles.faqList}>
              {faqItems.map((item, index) => {
                const isExpanded = expandedItem === index

                return (
                  <article
                    key={index}
                    className={`${styles.faqItem} ${isExpanded ? styles.expanded : ""}`}
                  >
                    <button
                      type="button"
                      className={styles.faqHeader}
                      onClick={() => setExpandedItem(isExpanded ? -1 : index)}
                    >
                      <div className={styles.faqNumber}>{index + 1}</div>

                      <div className={styles.faqHeaderContent}>
                        <h3 className={styles.faqQuestion}>{item.question}</h3>

                        <ChevronDown
                          className={`${styles.chevronFaq} ${isExpanded ? styles.rotated : ""}`}
                        />
                      </div>
                    </button>

                    {isExpanded && (
                      <div className={styles.faqAnswer}>
                        <div dangerouslySetInnerHTML={{ __html: item.answer }} />
                      </div>
                    )}
                  </article>
                )
              })}
            </div>
          </section>

          <section className={styles.faqSupportSection}>
            <div className={styles.supportCard}>
              <h3 className={styles.supportTitle}>¿No encuentras tu respuesta?</h3>

              <p className={styles.supportText}>
                Nuestro equipo de soporte está disponible para ayudarte
              </p>

              <a
                href="https://wa.me/50369383613"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.whatsappButton}
              >
                Contactar por WhatsApp
              </a>
            </div>
          </section>
        </div>
      </main>
    </div>
  )
}